export const version = {
    major: 1,
    minor: 3,
    patch: 610
}
